'use client';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { Iconify } from 'src/components/iconify';
import { EmptyContent } from 'src/components/empty-content';

import { BLOG_DETAILS } from '../constants/blog-copy';

// ----------------------------------------------------------------------

/** 「글을 찾을 수 없어요」 + 「블로그 목록으로」 — 없는 글(404)과 상세 렌더 오류 둘 다 이 화면이다 */
export function PostNotFound() {
  return (
    <Container sx={{ mt: 5, mb: 10 }}>
      <EmptyContent
        filled
        title={BLOG_DETAILS.notFoundTitle}
        action={
          <Button
            component={RouterLink}
            href={paths.home.blog}
            startIcon={<Iconify width={16} icon="solar:alt-arrow-left-linear" />}
            sx={{ mt: 3 }}
          >
            {BLOG_DETAILS.notFoundAction}
          </Button>
        }
        sx={{ py: 10 }}
      />
    </Container>
  );
}
